(function () {
  "use strict";

  function proxyPath() {
    var path = (window.theme && window.theme.followProxyPath) || "/apps/artfolio";
    return String(path).replace(/\/$/, "");
  }

  function fieldValue(form, name) {
    var el = form.elements[name];
    if (!el) return "";
    return String(el.value || "").trim();
  }

  function setStatus(el, text, isError) {
    if (!el) return;
    el.textContent = text || "";
    el.toggleAttribute("data-error", !!isError);
  }

  function buildStaffBody(payload) {
    var lines = [
      "Commission enquiry for " + payload.artist_name + ".",
      payload.artist_page ? "Artist page: https://theartfolio.co.uk" + payload.artist_page : "",
      payload.artist_details ? "About the artist: " + payload.artist_details : "",
      "",
      "From: " + payload.name + " <" + payload.email + ">",
      payload.phone ? "Telephone: " + payload.phone : "",
      payload.location ? "Town or area: " + payload.location : "",
      payload.size_note ? "Size or space: " + payload.size_note : "",
      payload.budget ? "Budget: " + payload.budget : "",
      "",
      payload.message
    ];
    return lines.filter(function (line, i, arr) {
      return line !== "" || (arr[i - 1] && arr[i - 1] !== "");
    }).join("\n");
  }

  function bindRoot(root) {
    if (!root || root.getAttribute("data-commission-bound")) return;
    root.setAttribute("data-commission-bound", "true");
    var dialog = root.querySelector("[data-commission-dialog]") || document.querySelector("[data-commission-dialog]");
    var form = (dialog && (dialog.querySelector("[data-commission-form]") || dialog.querySelector("form.artist-commission-form"))) || root.querySelector("form.artist-commission-form");
    if (!dialog || !form || typeof dialog.showModal !== "function") return;
    var status = form.querySelector("[data-commission-status]");
    var sendBtn = form.querySelector("[data-commission-send]");
    var meta = form.querySelector("[data-commission-meta]");
    form.setAttribute("novalidate", "novalidate");

    function open() {
      setStatus(status, "", false);
      if (sendBtn) sendBtn.disabled = false;
      dialog.showModal();
      var first = form.querySelector("input[name='contact[name]']");
      if (first) first.focus();
    }

    function close() {
      if (dialog.open) dialog.close();
    }

    document.addEventListener("click", function (event) {
      var btn = event.target.closest("[data-commission-open]");
      if (!btn) return;
      event.preventDefault();
      open();
    });
    dialog.addEventListener("click", function (event) {
      if (event.target === dialog) close();
      if (event.target.closest("[data-commission-close]")) {
        event.preventDefault();
        close();
      }
    });

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      if (sendBtn && sendBtn.disabled) return;
      var payload = {
        artist_slug: (meta && meta.getAttribute("data-artist-slug")) || "",
        artist_name: (meta && meta.getAttribute("data-artist-name")) || "",
        artist_page: (meta && meta.getAttribute("data-artist-page")) || "",
        artist_details: (meta && meta.getAttribute("data-artist-details")) || "",
        name: fieldValue(form, "contact[name]"),
        email: fieldValue(form, "contact[email]"),
        phone: fieldValue(form, "contact[phone]"),
        location: fieldValue(form, "contact[location]"),
        size_note: fieldValue(form, "contact[size]"),
        budget: fieldValue(form, "contact[budget]"),
        message: fieldValue(form, "contact[body]"),
        company: fieldValue(form, "contact[company]"),
        source_url: window.location.pathname + window.location.search
      };
      if (payload.name.length < 2) {
        setStatus(status, "Please add your name.", true);
        return;
      }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(payload.email)) {
        setStatus(status, "Please add a working email.", true);
        return;
      }
      if (payload.message.length < 12) {
        setStatus(status, "A little more about what you have in mind would help.", true);
        return;
      }
      if (payload.company) {
        setStatus(status, "Sent. We’ll be in touch from TheArtFolio.", false);
        form.reset();
        window.setTimeout(close, 800);
        return;
      }
      if (sendBtn) sendBtn.disabled = true;
      setStatus(status, "Sending…", false);

      var staffData = new FormData(form);
      staffData.set("contact[body]", buildStaffBody(payload));

      var save = fetch(proxyPath() + "/commission", {
        method: "POST",
        credentials: "same-origin",
        headers: { accept: "application/json", "content-type": "application/json" },
        body: JSON.stringify(payload)
      }).then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (body) {
          body = body || {};
          body.ok = res.ok && body.ok !== false && !body.error;
          body.status = res.status;
          return body;
        });
      }).catch(function () {
        return { ok: false, status: 0 };
      });

      var notify = fetch(form.getAttribute("action") || "/contact", {
        method: "POST",
        credentials: "same-origin",
        body: staffData,
        headers: { accept: "text/html" }
      }).catch(function () {
        return null;
      });

      Promise.all([save, notify]).then(function (results) {
        var saved = results[0];
        var mailed = results[1] && results[1].ok;
        if ((saved && saved.ok) || mailed) {
          setStatus(status, "Sent. We’ll be in touch from TheArtFolio.", false);
          form.reset();
          window.setTimeout(close, 1600);
          return;
        }
        if (sendBtn) sendBtn.disabled = false;
        var code = saved && saved.error;
        if (code === "rate_limited") {
          setStatus(status, "That’s a few enquiries in a short time. Try again shortly.", true);
          return;
        }
        setStatus(status, "Couldn’t send just now. Try again, or use the contact page.", true);
      });
    });
  }

  document.querySelectorAll("[data-artist-commission]").forEach(bindRoot);
})();
